import cn from "classnames";
import React, { FunctionComponent } from "react";

import { withStyles } from "coral-ui/hocs";

import formedicsLogo from "./formedics.png";
import styles from "./LogoHorizontal.css";

interface Props {
  className?: string;
  classes: typeof styles;
}

const LogoHorizontal: FunctionComponent<Props> = ({
  className,
  classes,
}) => (
  <>
    <h1 aria-hidden className={styles.hiddenTitle}>
      Formedics
    </h1>
    <img
      className={cn(styles.base, className)}
      src={formedicsLogo}
      alt=""
      aria-hidden="true"
    />
  </>
);

export default withStyles(styles)(LogoHorizontal);
